import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  return (
    <div className="product-card">
      <Link to={`/products/${product.id}`}>
        <div className="product-image">
          <img src={product.imageUrl} alt={product.name} />
          {product.isOnSale && <span className="sale-badge">Sale</span>}
        </div>
        <div className="product-info">
          <h3>{product.name}</h3>
          <div className="product-price">
            {product.isOnSale ? (
              <>
                <span className="sale-price">${product.salePrice}</span>
                <span className="original-price">${product.price}</span>
              </>
            ) : (
              <span>${product.price}</span>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
